import { Button } from 'components/Button/Button';
import { useDevice } from 'lib/hooks/useDevice';
import { useCustomNavigate } from 'lib/hooks/useCustomNavigate';
import { stagePathConfig } from 'data/stage';
import { TButtonType } from 'components/Button/Button.type';
import { useTenant } from 'lib/hooks/useTenant';
import useTripQuery from 'lib/react-query/Queries/useTripQuery';
import { useSessionLockStatus } from '@/lib/react-query/Queries/useSessionLockStatus';

type Props = {
  text: string;
  submit: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  buttonType: TButtonType;
};

const PaymentSubmit = ({
  submit,
  isLoading,
  isDisabled,
  text,
  buttonType,
}: Props) => {
  const navigate = useCustomNavigate();
  const { isMobile } = useDevice();
  const { isDA } = useTenant();
  const { data: tripData } = useTripQuery();
  const { isLocked } = useSessionLockStatus();

  // DealsAway: Payment comes after Rooms, unless Rooms was skipped.
  const hasDealsAwayRoomStage =
    isDA &&
    Boolean(tripData?.result.rooms && tripData.result.rooms.length > 0) &&
    !isLocked;
  const backPath = hasDealsAwayRoomStage
    ? stagePathConfig.rooms
    : stagePathConfig.traveller;

  return (
    <div>
      <hr className="md:hidden border-none h-px w-full bg-light-800" />
      <div className="p-5 bg-light-700 grid grid-cols-[1fr_2fr] gap-5 md:flex justify-between items-center">
        <Button
          text="Back"
          clickHandler={() => navigate(backPath)}
          size="medium"
          type="secondary-border"
          arrow="left"
          className="min-w-[6.25rem]"
          textClassName="!text-base"
        />
        <Button
          text={text}
          clickHandler={submit}
          size="medium"
          type={buttonType}
          isDisabled={isLoading}
          isLoading={isDisabled}
          arrow={isMobile ? undefined : 'right'}
          className="w-auto md:min-w-[15.625rem]"
        />
      </div>
    </div>
  );
};

export { PaymentSubmit };
